import { z } from 'zod'

export function conditionalRequiredZodError({
  fields,
  ctx,
  message,
}: {
  fields: {
    value: string | number | null | undefined
    path: string[]
  }[]
  ctx: z.RefinementCtx
  message: string
}) {
  fields.forEach((field) => {
    if (
      typeof field.value === 'undefined' ||
      field.value === null ||
      field.value === ''
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message,
        path: field.path,
      })
    }
  })
}
